<div class="top-header">
    <app-navigation-stepper
        [steps]="navigationSteps"
        [currentStepIndex]="2"
        [enforceLinearProgression]="true"
    ></app-navigation-stepper>
    <div class="action-container">
        <div class="d-flex flex-row align-items-center flex-wrap" style="margin-right: 40px">
            <label class="d-flex align-items-center">Multiply By
                <i class="fa fa-question-circle m-2" aria-hidden="true">
                    <div class="multiplyByToolTip">Multiplies values from financial statement that were reported as rounded. Changes will take effect after spread completion.</div>
                </i>
            </label>
            <select (change)="roundingSelectionChanged($event)" class="form-select w-auto" id="roundingInput" [value]="roundingSelection">
                <option value="ACTUALS">Actuals</option>
                <option value="HUNDREDS">Hundreds</option>
                <option value="THOUSANDS">Thousands</option>
                <option value="MILLIONS">Millions</option>
                <option value="BILLIONS">Billions</option>
                <option value="TRILLIONS">Trillions</option>
                <option value="LAKHS">Lakhs (100,000)</option>
                <option value="CRORES">Crores (10,000,000)</option>
            </select>
        </div>
        <button class="btn btn-outline-secondary" type="button" (click)="exitClicked.emit()">
            <span class="size">Cancel</span>
        </button>
        <div class="btn-separator">|</div>
        <button class="btn btn-primary" type="button" (click)="nextClicked.emit()">
            <span class="size">Merge Into Spread</span>
        </button>
    </div>
</div>
<div class="content-container row mx-0">
    <div class="col-4 scrollable-column fixed-document-width-col" id="box-drawer-container">
        <div class="section-header">
            <span class="panel-label">Selected page</span>
        </div>
        <app-box-drawer
            [allowEdit]="false"
            [inputImageWidth]="600"
            [boxes]="columnStructure"
            [sourceImageUrl]="pageImage?.normalRes?.signedUrl"
            scrollingContainerElementId="box-drawer-container"
        ></app-box-drawer>
    </div>
    <div class="col no-x-overflow">
        <div class="section-header">
            <span class="panel-label">{{ formatDataLabel }}</span>
        </div>
        <div class="table-container">
            <hot-table
                [hotId]="htDataService.hotId"
                [afterInit]="htDataService.afterTableInit"
                [colHeaders]="true"
                [rowHeaders]="true"
                [data]="htDataService.pageData$ | async"
                [settings]="{renderer: renderCell, contextMenu: htDataService.contextMenu}"
                [cells]="cellsFunction"
                [stretchH]="'all'"
                [licenseKey]="htDataService.handsOnTableLicense"
            >
            </hot-table>
        </div>
    </div>
</div>
